import LoginPage from '../pages/login';
import PersonalInfo from '../pages/personalinfo';
import UnderwriterDashboard from '../pages/underwriter';

export const USER_TYPES = {
  APPLICANT: 'APPLICANT',
  INTERNAL: 'INTERNAL'
};

// Add new pages here as you build them.
// - path: the URL
// - element: the page component
// - protected: true  -> only reachable when signed in (wrapped in ProtectedRoute)
//   protected: false -> public page (wrapped in PublicRoute, e.g. login)
//   protected: undefined -> public, no redirect logic at all
export const routes = [
  {
    path: '/login',
    element: LoginPage,
    protected: false
  },
  {
    path: '/underwriter',
    element: UnderwriterDashboard,
    protected: true,
    allowedUserTypes: [USER_TYPES.INTERNAL]
  },
  {
    path: '/personal-info',
    element: PersonalInfo,
    protected: true
  }
];

export const DEFAULT_PUBLIC_ROUTE = '/login';

export const landingRouteFor = (userType) =>
  userType === USER_TYPES.INTERNAL ? '/review' : '/apply/personal';
